import { CommonModule, DatePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { OrderLineItemDetailService } from "../../../core/services/order-line-item-detail.service";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { DatePickerModule } from "primeng/datepicker";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { computeMinDate } from "../../../core/utilities/mindate-function";

@Component({
  selector: "jni-inventory-order-line-item-details",
  templateUrl: "./inventory-order-line-item-details.component.html",
  styleUrls: ["./inventory-order-line-item-details.component.scss"],
  providers: [DatePipe],
  imports: [
    SelectModule,
    CommonModule,
    DatePickerModule,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
  ],
})
export class InventoryOrderLineItemDetailsComponent {
  @Input() parent!: FormGroup;
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() customerId = "";
  @Input() headerShipDate: string | Date | null = "";
  @Input() headerInhandDate = "";
  @Input() formErrors!: Record<string, string>;
  @Input() orderType = "";
  @Input() templateService = false;

  @Output() validationErrorEvent = new EventEmitter();

  shipDateCurrentdate = computeMinDate();
  inHandDateCurrentdate = computeMinDate();

  shipDate!: string | Date | null;
  inHandDate!: string;
  shipdate = "";

  @ViewChild("nameInput") inputNameRef!: ElementRef;
  @ViewChild("nameInput1") inputNameRef1!: ElementRef;
  constructor(
    private _orderLineItemDetailService: OrderLineItemDetailService,
    public datepipe: DatePipe
  ) {}

  onShipDateSelection(event: Date) {
    const shipDate = new Date(event);
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.parent.patchValue({
      detail: {
        shipDate: this.shipDate,
      },
    });
  }

  clearShippingMethod() {
    this.parent.patchValue({
      detail: {
        accountNumberD365: "",
      },
    });
  }

  onInHandDateSelection(event: Date) {
    //this.inHandDate = new Date(event).toLocaleDateString();
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.parent.patchValue({
      detail: {
        inHandDate: this.inHandDate,
      },
    });
  }

  clearInHandDateAndShipDate() {
    this.parent.patchValue({
      detail: {
        inHandDate: "",
        shipDate: "",
      },
    });

    // (<HTMLInputElement>document.getElementById('shipdate')).value = '';
    // this.inputNameRef.nativeElement.onblur();
    // (<HTMLInputElement>document.getElementById('inhanddate')).value = '';
    // this.inputNameRef1.nativeElement.onblur();
  }

  onShippingMethodSelect(shippingMethodCode: SelectChangeEvent) {
    const shippingMethod = shippingMethodCode.value as string;
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethod
    );

    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.parent.patchValue({
          detail: {
            accountNumberD365: selectedShippingMethod.jniFreightAcctNumD365,
          },
        });
      } else {
        this._orderLineItemDetailService
          .getClientFreightAccountNumber(this.customerId)
          .subscribe({
            next: res => {
              if (res.data) {
                this.parent.patchValue({
                  detail: {
                    accountNumberD365: res.data,
                  },
                });
              } else {
                this.parent.patchValue({
                  detail: {
                    accountNumberD365: "",
                  },
                });
              }
            },
            error: () => {
              this.parent.patchValue({
                detail: {
                  accountNumberD365: "",
                },
              });
            },
          });
      }
    }
  }

  applyAccountLengthValidation(event: FocusEvent) {
    // Do not mutate the value when the field is auto-populated with a
    // Nadel freight account and must remain read-only.
    if (this.isNadelFreightAccount) {
      return;
    }

    const target = event.target as HTMLInputElement;
    if (target.value) {
      this.parent.patchValue({
        detail: {
          accountNumberD365: target.value.substring(0, 40),
        },
      });
    }
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  /**
   * Returns true when the currently selected shipping method is a
   * Nadel freight account (e.g. FedEx / UPS Nadel Account). In that case
   * the supplier account number must be auto-populated and non-editable.
   */
  get isNadelFreightAccount(): boolean {
    const shippingMethodCode = this.parent?.get([
      "detail",
      "shippingMethod",
    ])?.value;
    if (!shippingMethodCode || !this.shippingProductsList?.length) {
      return false;
    }
    const method = this.shippingProductsList.find(
      x => x.modeCodeD365 === shippingMethodCode
    );

    if (method?.useFreightAccountD365?.toLowerCase() !== "yes") {
      return false;
    }

    // Client requirement: only hide/lock the account number when the
    // shipping method is UPS or FedEx (Nadel freight accounts).
    const description = method?.modeDescriptionD365?.toLowerCase() ?? "";
    return description.includes("ups") || description.includes("fedex");
  }

  onClearShippingMethodSelection() {
    this.parent.patchValue({
      detail: {
        accountNumberD365: "",
      },
    });
  }
}
